import { logError } from './logger';
import { hasOwnProperty } from './types';

import { translate } from '@/translations/translations-config';

const errorToMessage = {
  error_unexpected: 'msg_error_unexpected',
  error_invalid_credentials: 'msg_error_invalid_credentials',
  error_forbidden: 'msg_error_forbidden',
  error_availability_change_invalid_role: 'msg_error_availability_change_invalid_role',
  error_availability_change_time_expired: 'msg_error_availability_change_time_expired',
} as const;

export const translateBeErrorMessage = (key: string): string => {
  if (hasOwnProperty(errorToMessage, key)) {
    return translate(errorToMessage[key]);
  }

  logError(`Missing BE error translations: ${key}`);
  return key;
};
